import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "react-modal";
import ReactDropzone from "react-dropzone";
import { addLandaSize } from "Utils";

import IconClose from "../../Icons/IconClose";
import IconFolder from "../../Icons/IconFolder";
import IconUpload from "../../Icons/IconUpload";
import IconCheck from "../../Icons/IconCheck";

import { resetMaskSelector, setMaskSelector } from "Actions";
import { fetchMedias, uploadMediaFiles } from "Thunks";

import { TTP_API_URL } from "Config";
import styles from "./MaskSelector.local.scss";

import _ from "i18n";

export class MaskSelector extends Component {
  static propTypes = {
    loggedAs: PropTypes.string,
    isOpen: PropTypes.bool
  };

  state = {
    newSelectedMask: null
  };

  fetchItems = () => {
    const { fetchMedias } = this.props;
    const cols = 4;
    const rows = 4;

    fetchMedias({ type: "MASK", limit: rows * cols - 1 });
  };

  afterOpenModal = () => {
    this.setState({ newSelectedMask: this.props.selectedMask });
    this.fetchItems();
  };

  closeModal = () => {
    this.setState({ newSelectedMask: null });
    this.props.setMaskSelector({ isOpen: false });
  };

  applyMask = () => {
    this.props.setMaskSelector({ selectedMask: this.state.newSelectedMask });
    this.closeModal();
  };

  toggleSelectedMask = mask => {
    const { newSelectedMask } = this.state;

    if (mask && newSelectedMask && newSelectedMask.id === mask.id) {
      this.setState({ newSelectedMask: null });
      return;
    }

    this.setState({ newSelectedMask: mask });
  };

  renderFetchingState() {
    return [...Array(11).keys()].map(key => (
      <div key={key} className={`cell medium-3 small-2 ${styles.listItem}`}>
        <div className={styles.mask} />
      </div>
    ));
  }

  renderMasks() {
    const { newSelectedMask } = this.state;
    const { masks, fetching, error } = this.props;

    let fetchingState = "none";

    if (fetching) {
      fetchingState = "fetching";
    } else if (error && error.code !== 404) {
      fetchingState = "error";
    } else if (error && error.code === 404) {
      fetchingState = "success"; // This an empty response (not an error for lists)
    } else {
      fetchingState = "success";
    }

    if (fetchingState === "none") {
      return null; // First render (before any request start )
    } else if (fetchingState === "fetching") {
      return this.renderFetchingState();
    } else if (fetchingState === "error") {
      return null; // RENDER ERROR COMPONENT
    } else if (masks.length === 0) {
      return null;
    }

    return masks.map(mask => (
      <div key={mask.id} className={`cell medium-3 small-2 ${styles.listItem}`}>
        <div
          className={styles.mask}
          style={{
            backgroundImage: `url("${
              mask.fullMediaUrl
                ? addLandaSize(mask.fullMediaUrl, 600)
                : TTP_API_URL + "/" + mask.webPath
            }")`
          }}
          onClick={() => this.toggleSelectedMask(mask)}
        >
          {newSelectedMask &&
            newSelectedMask.id === mask.id && (
              <div className={styles.maskSelected}>
                <div className={styles.maskSelectedIcon}>
                  <IconCheck size={12} />
                </div>
              </div>
            )}
        </div>
      </div>
    ));
  }

  onDropMask = (acceptedFiles, rejectedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }

    // TODO rejectedFiles ?

    this.props.uploadMediaFiles(acceptedFiles, "MASK");
  };

  renderAddMask() {
    return (
      <div className={`cell medium-3 small-2 ${styles.listItem}`}>
        <ReactDropzone
          accept={["image/*"]}
          onDrop={this.onDropMask}
          className={styles.dropzone}
          activeClassName={styles.dropzoneActive}
          rejectClassName={styles.dropzoneReject}
        >
          <IconUpload size={50} />
        </ReactDropzone>
      </div>
    );
  }

  renderUploadingMasks() {
    const { uploadingMasks } = this.props;

    if (uploadingMasks.length === 0) {
      return null;
    }

    return uploadingMasks.map(({ id, progress, file }) => (
      <div key={id} className={`cell medium-3 small-2 ${styles.listItem}`}>
        <div
          className={`${styles.mask} ${styles.uploadingMask}`}
          style={{
            backgroundImage: `url("${URL.createObjectURL(file)}")`
          }}
        >
          <div className={styles.uploadingMaskOverlay} />
          <div
            className="progress"
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <span
              className="progress-meter"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    ));
  }

  render() {
    const { newSelectedMask } = this.state;
    const { isOpen, lng } = this.props;
    const titleAttr = "title" + lng.charAt(0).toUpperCase() + lng.slice(1);
    const descriptionAttr =
      "description" + lng.charAt(0).toUpperCase() + lng.slice(1);

    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        className={{
          base: styles.modalContent,
          afterOpen: styles.modalContentAfterOpen,
          beforeClose: styles.modalContentBeforeClose
        }}
        overlayClassName={{
          base: styles.modalOverlay,
          afterOpen: styles.modalOverlayAfterOpen,
          beforeClose: styles.modalOverlayBeforeClose
        }}
        closeTimeoutMS={300}
        contentLabel="Mask selector"
      >
        <div className={styles.modal}>
          <div className={styles.close} onClick={this.closeModal}>
            <IconClose size={14} />
          </div>
          <div className={styles.header}>
            <IconFolder className={styles.headerIcon} size={29} />
            {_("Apply a mask to your medias")}
          </div>
          <div className={styles.body}>
            <div className={styles.list}>
              <div className={styles.listHeader}>
                {_("Select or import your mask")}
              </div>
              <div className={`grid-x ${styles.listBody}`}>
                {this.renderAddMask()}
                {this.renderUploadingMasks()}
                {this.renderMasks()}
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.infoHeader}>{_("Mask informations")}</div>
              <ul className={styles.infoList}>
                <li>
                  <label>{_("Title")} : </label>
                  {newSelectedMask && newSelectedMask[titleAttr]}
                </li>
                <li>
                  <label>{_("Description")} : </label>
                  {newSelectedMask && newSelectedMask[descriptionAttr]}
                </li>
                <li>
                  <label>{_("Uploaded at")} : </label>
                  {newSelectedMask && newSelectedMask.createdAt}
                </li>
                <li>
                  <label>{_("File type")} : </label>
                  {newSelectedMask &&
                    newSelectedMask.meta &&
                    newSelectedMask.meta.mimeType}
                </li>
                <li>
                  <label>{_("File size")} : </label>
                  {newSelectedMask &&
                    newSelectedMask.meta &&
                    newSelectedMask.meta.size}
                </li>
                <li>
                  <label>{_("Dimensions")} : </label>
                  {newSelectedMask &&
                  newSelectedMask.meta &&
                  newSelectedMask.meta.width &&
                  newSelectedMask.meta.height
                    ? `${newSelectedMask.meta.width} x ${
                        newSelectedMask.meta.height
                      }`
                    : ""}
                </li>
              </ul>
              <div className={styles.actions}>
                <button
                  className={styles.cancelButton}
                  onClick={this.closeModal}
                >
                  {_("Cancel")}
                </button>
                <button className={styles.applyButton} onClick={this.applyMask}>
                  {_("Apply")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  lng: state.params.lng,
  isOpen: state.maskSelector.isOpen,
  selectedMask: state.maskSelector.selectedMask,
  masks: state.medias.masks.items,
  fetching: state.medias.masks.fetching,
  fetched: state.medias.masks.fetched,
  error: state.medias.masks.items.error,
  uploadingMasks: state.medias.uploading.items
});

const mapDispatchToProps = dispatch => ({
  resetMaskSelector: () => dispatch(resetMaskSelector()),
  setMaskSelector: options => dispatch(setMaskSelector(options)),
  fetchMedias: options => dispatch(fetchMedias(options)),
  uploadMediaFiles: (files, docType) =>
    dispatch(uploadMediaFiles(files, docType))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaskSelector);



// WEBPACK FOOTER //
// ./src/components/Reveal/MaskSelector/MaskSelector.js